// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9948) return "static/chunks/9948-fb7b75aa553e355c.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"3496":"graphql-print","4254":"56c12eb5","5970":"lottie"}[chunkId] || chunkId) + "." + {"3496":"7ef39872c8b54dd4","4254":"cfaf0f642ce9413b","5497":"3f94129414991dd8","5970":"30568860e6b3fcc4","6152":"3cca1108cd40f9ac"}[chunkId] + ".js";
};